export default "__VITE_ASSET__cX8LiTLA__"